import $ from 'jquery';
import { createDebounce } from './util';
import Choices from 'choices.js';
import Cleave from 'cleave.js';
const { dayjs } = window.sfp.scriptLibs;

/**
 * Example:
 * formId: MyCustomForm
 * absoluteInputName: tx_htwevents_eventform[MyCustomForm][__state]
 * return: __state
 *
 * @param {string} formId
 * @param {string} absoluteInputName
 * @returns {string}
 */
const getRelativeInputName = function (formId, absoluteInputName) {
  return absoluteInputName.slice(
    absoluteInputName.indexOf(formId) + formId.length + 2,
    -1
  );
};

export class Form {
  constructor(formElement) {
    this.$form = $(formElement);
    this.formId = this.$form.attr('id');

    try {
      this.initializeOptions();
      this.elementConfigs = this.options.elements || {};
      this.formSubmitClass =
        this.options.formSubmitClass || 'Plugin--Form__Submit';
      this.initializeSelects();
      this.initializeDateInputs();
      this.update();
      this.bindEvents();
    } catch (err) {
      console.error(err);
    }

    // We never stop this from happening
    this.$form.show();
  }

  initializeOptions() {
    this.options = this.$form.data('form');
  }

  bindEvents() {
    this.bindUpdate();

    if (this.formSubmitClass) {
      this.$form.on('submit', () => {
        this.$form.addClass(this.formSubmitClass);
      });
    }
  }

  bindUpdate() {
    // edge doesnt support input events for some form elements
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7194628/
    const onChangeSelector =
      'select,input[type="checkbox"],input[type="radio"],input[type="file"]';

    this.$form.on(
      'input',
      createDebounce((evt) => {
        if ($(evt.target).is(onChangeSelector)) {
          return;
        }
        this.update();
      })
    );

    this.$form.on('change', onChangeSelector, () => {
      this.update();
    });
  }

  initializeSelects() {
    const choicesConfig = {
      searchEnabled: true,
      shouldSort: false,
      removeItemButton: true,
      itemSelectText: '',
    };

    this.$form.find('select').each((i, e) => {
      new Choices(e, choicesConfig);
    });
  }

  initializeDateInputs() {
    const nowFormatted = dayjs().format('DD.MM.YYYY');

    this.$form.find('.mdc-text-field--date input').each((key, element) => {
      $(element).attr('placeholder', nowFormatted);
    });
  }

  /**
   * Collect form input data and return a normalized object
   *
   * @returns {*}
   */
  getData() {
    return this.$form.serializeArray().reduce((acc, next) => {
      const elementName = getRelativeInputName(this.formId, next.name);

      acc[elementName] = next.value;

      return acc;
    }, {});
  }

  update() {
    this.updateVisibility();
  }

  /**
   * Iterates through all form elements and updates the element visibility based on data settings
   */
  updateVisibility() {
    const formValues = this.getData();
    $.each(this.elementConfigs, (elementIdentifier, settings) => {
      /**
       * @var {object} settings
       * @property {object} settings.visibleWhen
       * @property {null|string} settings.visibleWhen.value
       * @property {string} settings.visibleWhen.element
       */
      const visibleWhen = settings.visibleWhen;
      if (!visibleWhen) {
        return;
      }

      const $element = $(
        '[data-element-identifier="' + elementIdentifier + '"]'
      );

      const valueShould = visibleWhen.value;
      const valueIs = formValues[visibleWhen.element];

      const valueHasToBeEqual = !!valueShould;
      const valueIsSet = !!valueIs;
      const valueIsEqual = valueIs === valueShould;

      const elementVisible = (!valueHasToBeEqual && valueIsSet) || valueIsEqual;
      if (elementVisible) {
        // TODO: Refactor this: There should be a visibility check in the FormFactory getFormData
        $element.find('textarea, input, select').prop('disabled', false);
        $element.show();
      } else {
        $element.hide();
        $element.find('textarea, input, select').prop('disabled', true);
      }
    });
  }
}
